var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#user_svg__a)",
    fillRule: "evenodd",
    d: "M6.75 6a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M10 1.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5M17.75 18v-5.75H2.25V18h1.5v-4.25h12.5V18z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "user_svg__a",
    x1: 15.564,
    x2: -1.147,
    y1: 1.52,
    y2: 13.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgUser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi43NSA2QzYuNzUgNC4yMDUwNyA4LjIwNTA3IDIuNzUgMTAgMi43NUMxMS43OTQ5IDIuNzUgMTMuMjUgNC4yMDUwNyAxMy4yNSA2QzEzLjI1IDcuNzk0OTMgMTEuNzk0OSA5LjI1IDEwIDkuMjVDOC4yMDUwNyA5LjI1IDYuNzUgNy43OTQ5MyA2Ljc1IDZaTTEwIDEuMjVDNy4zNzY2NSAxLjI1IDUuMjUgMy4zNzY2NSA1LjI1IDZDNS4yNSA4LjYyMzM1IDcuMzc2NjUgMTAuNzUgMTAgMTAuNzVDMTIuNjIzNCAxMC43NSAxNC43NSA4LjYyMzM1IDE0Ljc1IDZDMTQuNzUgMy4zNzY2NSAxMi42MjM0IDEuMjUgMTAgMS4yNVpNMTcuNzUgMThWMTIuMjVIMi4yNVYxOEgzLjc1VjEzLjc1SDE2LjI1VjE4SDE3Ljc1WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzM0NThfNjE1NTApIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMzQ1OF82MTU1MCIgeDE9IjE1LjU2NDEiIHkxPSIxLjUyMDE2IiB4Mj0iLTEuMTQ2NjQiIHkyPSIxMy4wNjY4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIG9mZnNldD0iMC4xMjYzMDIiIHN0b3AtY29sb3I9IiNGRjc4ODAiLz4KPHN0b3Agb2Zmc2V0PSIwLjM3NDQiIHN0b3AtY29sb3I9IiMxNUNGRTQiLz4KPHN0b3Agb2Zmc2V0PSIwLjYyNTE1NCIgc3RvcC1jb2xvcj0iIzNCRjJBNSIvPgo8c3RvcCBvZmZzZXQ9IjAuODc2MzQ4IiBzdG9wLWNvbG9yPSIjNjY3NUZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";